import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ResidentProfile.ScreeningTab.Title',
    defaultMessage: 'Screening',
  },
  infoBanner: {
    id: 'App.ResidentProfile.ScreeningTab.InfoBanner',
    defaultMessage:
      'Screenings can be run for existing or newly added household members. ' +
      'To run different screening types for different individuals, separate screening submissions are required.',
  },
  submitScreening: {
    id: 'App.ResidentProfile.ScreeningTab.SubmitScreening',
    defaultMessage: 'Submit Screening',
  },
  historyTitle: {
    id: 'App.ResidentProfile.ScreeningTab.HistoryTitle',
    defaultMessage: 'Resident Screening History',
  },
  emptyTitle: {
    id: 'App.ResidentProfile.ScreeningTab.EmptyTitle',
    defaultMessage: 'No Screenings Started',
  },
  emptyDescription: {
    id: 'App.ResidentProfile.ScreeningTab.EmptyDescription',
    defaultMessage: 'There are no available screenings to show',
  },
  modalTitle: {
    id: 'App.ResidentProfile.ScreeningTab.ModalTitle',
    defaultMessage: 'Submit Screening',
  },
  estimatedMonthlyRentAmount: {
    id: 'App.ResidentProfile.ScreeningTab.EstimatedMonthlyRentAmount',
    defaultMessage: 'Estimated Monthly Rent Amount',
  },
  estimatedMonthlyRentAmountTooltip: {
    id: 'App.ResidentProfile.ScreeningTab.EstimatedMonthlyRentAmountTooltip',
    defaultMessage:
      'Some screening providers may use this amount as part of their review.',
  },
  estimatedMonthlyRentAmountError: {
    id: 'App.ResidentProfile.ScreeningTab.EstimatedMonthlyRentAmountError',
    defaultMessage: 'Amount must be between $1 and $25,000',
  },
  purposeOfScreening: {
    id: 'App.ResidentProfile.ScreeningTab.PurposeOfScreening',
    defaultMessage: 'Purpose of Screening',
  },
  screeningType: {
    id: 'App.ResidentProfile.ScreeningTab.ScreeningType',
    defaultMessage: 'Screening Type',
  },
  householdMember: {
    id: 'App.ResidentProfile.ScreeningTab.HouseholdMember',
    defaultMessage: 'Household Member',
  },
  householdMemberTooltip: {
    id: 'App.ResidentProfile.ScreeningTab.HouseholdMemberTooltip',
    defaultMessage:
      'Select household members to screen. To run different screening types per person, submit separate screenings.',
  },
  cancel: {
    id: 'App.ResidentProfile.ScreeningTab.Cancel',
    defaultMessage: 'Cancel',
  },
  confirmAndSubmit: {
    id: 'App.ResidentProfile.ScreeningTab.ConfirmAndSubmit',
    defaultMessage: 'Confirm & Submit',
  },
  screeningSubmittedTitle: {
    id: 'App.ResidentProfile.ScreeningTab.ScreeningSubmittedTitle',
    defaultMessage: 'Screening Submitted',
  },
  screeningSubmittedMessage: {
    id: 'App.ResidentProfile.ScreeningTab.ScreeningSubmittedMessage',
    defaultMessage: 'The screening has been submitted successfully.',
  },
  screeningErrorTitle: {
    id: 'App.ResidentProfile.ScreeningTab.ScreeningErrorTitle',
    defaultMessage: 'Screening Error',
  },
  screeningErrorMessage: {
    id: 'App.ResidentProfile.ScreeningTab.ScreeningErrorMessage',
    defaultMessage:
      'There was an error submitting the screening. Please try again.',
  },
  selectPurposeOfScreening: {
    id: 'App.ResidentProfile.ScreeningTab.SelectPurposeOfScreening',
    defaultMessage: 'Choose',
  },
  selectScreeningType: {
    id: 'App.ResidentProfile.ScreeningTab.SelectScreeningType',
    defaultMessage: 'Choose',
  },
  selectHouseholdMember: {
    id: 'App.ResidentProfile.ScreeningTab.SelectHouseholdMember',
    defaultMessage: 'Choose',
  },
  noPermissionTooltip: {
    id: 'App.ResidentProfile.ScreeningTab.NoPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  incompleteApplicationFieldsTooltip: {
    id: 'App.ResidentProfile.ScreeningTab.IncompleteApplicationFieldsTooltip',
    defaultMessage:
      'Required fields for screening are not completed or saved for this member. ' +
      'Go to the Lease App tab and review the application.',
  },
  employmentStatus: {
    id: 'App.ResidentProfile.ScreeningTab.EmploymentStatus',
    defaultMessage: 'Employment Status',
  },
  selectEmploymentStatus: {
    id: 'App.ResidentProfile.ScreeningTab.SelectEmploymentStatus',
    defaultMessage: 'Choose',
  },
  annualIncome: {
    id: 'App.ResidentProfile.ScreeningTab.AnnualIncome',
    defaultMessage: 'Annual Income',
  },
  annualIncomeError: {
    id: 'App.ResidentProfile.ScreeningTab.AnnualIncomeError',
    defaultMessage: 'Annual income must be greater than $0',
  },
  annualIncomeMaxError: {
    id: 'App.ResidentProfile.ScreeningTab.AnnualIncomeMaxError',
    defaultMessage: 'Annual income must be $999,999,999,999.99 or less',
  },
  missingInfoHeader: {
    id: 'App.ResidentProfile.ScreeningTab.MissingInfoHeader',
    defaultMessage: 'Missing Household Member Information',
  },
  missingMiniProfileFieldsTooltip: {
    id: 'App.ResidentProfile.ScreeningTab.MissingMiniProfileFieldsTooltip',
    defaultMessage:
      'Missing required information. Select their name in the Household mini profile, ' +
      'complete missing information, & save.',
  },
});
export default messages;
